<div *ngIf="this.address">
  <iframe title="Map of program location"
          width="300"
          height="300"
          style="border:0"
          [src]="('https://www.google.com/maps/embed/v1/place?q='+this.address+'&key='+this.apiKey) | safe">
  </iframe>
</div>
